<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">สร้างบิลขาย</h2>
            <div class="row">
                <div class="col-sm-6">
                    <!-- Customer select -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">รหัสลูกค้า</label>
                        <div class="col-sm-8">
                            <multiselect
                                v-model="form.customer"
                                :options="optionCustomer"
                                @input="getCustomerOther(form.customer)"
                                track-by="id"
                                :customLabel="customWithName"
                                :show-labels="false"
                                placeholder="เลือกลูกค้า">
                            </multiselect>
                        </div>
                    </div>
                    <!-- Customer data -->
                    <template v-if="form.customer">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">ลูกค้า</label>
                            <div class="col-sm-8 col-form-label">
                                <p>
                                    {{ form.customer.first_name }}
                                    {{ form.customer.last_name }}
                                </p>
                                <p>{{ form.customer.address }}</p>
                                <p>โทร {{ form.customer.phone }}</p>
                            </div>
                        </div>
                    </template>
                    <template v-if="form.customer">
                        <div class="form-group row">
                            <label
                                class="col-sm-4 col-form-label text-capitalize text-right">พนักงานขาย</label>
                            <div class="col-sm-8 col-form-label">
                                <span v-if="form.customer.sale">
                                    {{ form.customer.sale.sale_id }} {{ form.customer.sale.name }}
                                </span>
                            </div>
                        </div>
                    </template>
                    <!-- Customer other -->
                    <div class="form-group row"
                         v-if="(optionCustomerOther.length > 0 && form.customer) || form.customer_other_id">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">ลูกค้ารายย่อย</label>
                        <div class="col-sm-8">
                            <multiselect
                                :options="optionCustomerOther"
                                v-model="form.customer_other"
                                track-by="store_name"
                                @input="getInvoiceTransportPrice"
                                label="store_name"
                                :show-labels="false"
                                placeholder="เลือกลูกค้า">
                            </multiselect>
                        </div>
                    </div>
                    <!-- other price form-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label
                           text-capitalize text-right">+โฟม</label>
                        <div class="col-sm-8">
                            <b-form-select v-model="form.other_price_form"
                                           @input="selectOtherPrice"
                                           class="w-50"
                                           :options="priceForm">
                            </b-form-select>
                        </div>
                    </div>
                    <!-- remark -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label
                           text-capitalize text-right">หมายเหตุ</label>
                        <div class="col-sm-8">
                            <textarea class="form-control" v-model="form.remark"></textarea>
                        </div>
                    </div>
                    <!-- other price -->
                    <!--<div class="form-group row">-->
                    <!--<label class="col-sm-4 col-form-label-->
                    <!--text-capitalize text-right">+เบ็ดเตล็ด</label>-->
                    <!--<div class="col-sm-8">-->
                    <!--<input type="number" class="form-control w-50"-->
                    <!--v-model="form.other_price"/>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>

                <div class="col-sm-6">
                    <!-- DO -->
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลือกใบจองสินค้า(สำหรับสร้างบิลขายต่อเนื่อง)</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="orderSelected"
                                class="form-control select"
                                :options="optionOrder"
                                @input="setForm(orderSelected)"
                                @search-change="searchOrder_id"
                                :show-labels="false"
                                :customLabel="orderDO"
                                placeholder="ใบจองสินค้า"
                                track-by="id"
                                style="border:none;padding:0">
                                <template slot="noResult">ไม่พบใบจอง</template>
                                <template slot="noOptions">ค้นหาใบจอง</template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- invoice id -->
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">เลขที่ใบบิล</label>
                        <div class="col-sm-6">
                            <masked-input v-model="form.invoice_id"
                                          :disabled="!canViewSuperAdmin"
                                          mask="TN111111111"
                                          placeholder="เลขที่ TN"
                                          class="form-control"
                                          type="text"/>
                        </div>
                    </div>
                    <!---transport_type---->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">ประเภทรถ</label>
                        <div class="col-sm-6">
                            <b-form-select :options="optionTransportType"
                                           v-on:input="getDriverFormTransportType"
                                           :disabled="disabledtransport"
                                           @input="setIDTransportation(form.transport_type)"
                                           v-model="form.transport_type_id"
                                           @change="disabled_transport">
                            </b-form-select>
                        </div>
                    </div>
                    <!-- driver select -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">คนขับรถ</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.driver"
                                @input="checkInvoiceFormDriver(form.driver)"
                                :options="optionDriver"
                                track-by="id"
                                :disabled="disabledtransport"
                                :hidden="disabledtransport"
                                :customLabel="nameWithType"
                                :show-labels="false"
                                placeholder="โปรดเลือกคนขับ">
                            </multiselect>
                            <div style="display: none">
                                {{
                                    form.transport_type_name = form.transport_type_name ? form.transport_type_name : form.driver && form.driver.transport_type ? form.driver.transport_type.name : ''
                                }}
                            </div>
                        </div>
                    </div>
                    <!-- transportation select -->
                    <div class="form-group row" v-if="form.transport_type_id== type_transport">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">การขนส่ง</label>
                        <div class="col-sm-6">
                            <multiselect
                                v-model="form.transportation"
                                :options="optionTransportation"
                                track-by="id"
                                label="name"
                                :disabled="disable_select"
                                :show-labels="false"
                                placeholder="การขนส่ง">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.driver && invoice_driver.length > 0" style="color: red">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">ค้างใบส่งของ</label>
                        <div>
                            <div class="col-sm-12">
                                <span v-for="invoice in invoice_driver">
                                    {{ invoice.invoice_id }} {{ invoice.date | formatDate }}<br>
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- order id -->
                    <div class="form-group row" v-if="form.order_number">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่ใบจอง
                        </label>
                        <div class="col-sm-6">
                            <input
                                class="form-control"
                                disabled
                                v-model="form.order_number"/>
                        </div>
                    </div>

                    <div
                        class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            สถานะใบแจ้งหนี้
                        </label>
                        <div class="col-sm-6">
                            <b-form-select
                                disabled
                                v-model="form.invoice_status_id"
                                :options="invoiceStatus">
                            </b-form-select>
                        </div>
                    </div>

                    <div
                        class="form-group row"
                        v-if="form.status && form.status.id === 7">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            สถานะใบบิล
                        </label>
                        <div class="col-sm-6">
                            <template v-if="reopenStatus">
                                <input
                                    class="form-control"
                                    value="เปิดใบบิลใหม่"
                                    disabled/>
                            </template>
                            <template v-else-if="form.invoice_status_id==7 && form.reopen_status==1">
                                <input
                                    class="form-control"
                                    value="ยกเลิก (เปิดใบบิลใหม่)"
                                    disabled/>
                            </template>
                            <template v-else>
                                <input
                                    class="form-control"
                                    v-model="form.status.name"
                                    disabled/>
                            </template>
                        </div>
                    </div>

                    <!-- invoice date -->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่ออกใบบิล
                        </label>
                        <div class="col-sm-6">
                            <date-picker v-model="form.date"
                                         placeholder="วันที่ออกบิลขาย"
                                         class="w-100"
                                         :format="changeFormat"
                                         :lang="lang">
                            </date-picker>
                        </div>
                    </div>
                    <!--มีพ่วงการขนส่ง-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_transport_other}">
                                <input type="checkbox"
                                       :disabled="form.transport_type_id == 4"
                                       v-model="form.status_transport_other"
                                       :value="1"
                                       class="form-check-input"
                                       id="transportation">
                                <label class="form-check-label" for="transportation">มีพ่วงการขนส่ง</label>
                            </div>
                        </div>
                    </div>
                    <!--payment status-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_have_old}">
                                <input type="checkbox"
                                       v-model="form.status_have_old"
                                       :value="1"
                                       class="form-check-input"
                                       id="exampleCheck1">
                                <label class="form-check-label" for="exampleCheck1">มีการเก็บเก่า</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_payment}">
                                <input type="checkbox"
                                       v-model="form.status_payment"
                                       :value="1"
                                       class="form-check-input"
                                       id="status_payment">
                                <label class="form-check-label" for="status_payment">เก็บเงินสด/เช็ค</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_return}">
                                <input type="checkbox"
                                       v-model="form.status_return"
                                       :value="1"
                                       class="form-check-input"
                                       id="status_return"/>
                                <label class="form-check-label" for="status_return">มีคืนสินค้า</label>
                            </div>
                        </div>
                    </div>
                    <!---status_before_transport--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_before_transport}">
                                <input type="checkbox"
                                       v-model="form.status_before_transport"
                                       :value="1"
                                       id="transfer"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="transfer">โอนเงินก่อนส่งของ</label>
                            </div>
                        </div>
                    </div>
                    <!---status_tax_receipt--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_tax_receipt}">
                                <input type="checkbox"
                                       v-model="form.status_tax_receipt"
                                       :value="1"
                                       id="tax_receive"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="tax_receive">ขอใบกำกับภาษี</label>
                            </div>
                        </div>
                    </div>
                    <!---status_receive--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_receive}">
                                <input type="checkbox"
                                       v-model="form.status_receive"
                                       :value="1"
                                       id="status_receive"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_receive">มารับเอง</label>
                            </div>
                        </div>
                    </div>
                    <!---status_not_pay--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_not_pay}">
                                <input type="checkbox"
                                       v-model="form.status_not_pay"
                                       :value="1"
                                       id="status_not_pay"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_not_pay">บิลไม่มีราคา</label>
                            </div>
                        </div>
                    </div>
                    <!---status_sale_receive--->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right"></label>
                        <div class="col-sm-8">
                            <div class="form-check" :class="{'text-primary' :form.status_sale_receive}">
                                <input type="checkbox"
                                       v-model="form.status_sale_receive"
                                       :value="1"
                                       @change="getInvoiceTransportPrice"
                                       id="status_sale_receive"
                                       class="form-check-input"/>
                                <label class="form-check-label" for="status_sale_receive">เซลล์ขนส่ง</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--table ค่าขนส่ง-->
            <div class="col-sm-12 table-responsive" style="min-height: 500px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">รหัสสินค้า</th>
                        <th scope="col">ชื่อสินค้า</th>
                        <th width="50px" scope="col">จำนวน</th>
                        <th width="150px" scope="col">ราคา/หน่วย</th>
                        <th width="100px" scope="col">(+) เบ็ดเตล็ด</th>
                        <th scope="col" width="120px">(-)ส่วนลดพิเศษ</th> <!--สำหรับเซลล์--->
                        <th scope="col" width="150px">โปรโมชั่น</th>
                        <th width="50px" scope="col">ลด</th>
                        <th scope="col">ราคา/รวม</th>
                        <th scope="col">เพิ่ม / ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--invoice multi-->
                    <template v-for="(details, index) in form.details">
                        <tr>
                            <!--ลำดับ-->
                            <td>{{ index + 1 }}</td>
                            <!--รหัสสินค้า-->
                            <td align="center" style="width: 150px;">
                                <template v-if="details.product">
                                    {{ details.product.sku }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <!--ชื่อสินค้า-->
                            <td align="center" style="width: 150px;">
                                <template v-if="details.product">
                                    {{ details.product.name }}
                                </template>
                                <template v-else>
                                    <span style="color: red">สินค้านี้ถูกลบจากคลังแล้ว</span>
                                </template>
                            </td>
                            <!--จำนวน-->
                            <td align="center">
                                <input style="width: 100px;"
                                       v-model="details.quantity"
                                       v-on:focusout="calculatePromotionArray(form.details)"
                                       class="form-control"/>
                            </td>
                            <!--ราคา/หน่วย-->
                            <td align="center">
                                <template v-if="form.customer && form.customer.special_customer == 1">
                                    <input class="form-control" v-model="details.price"/>
                                </template>
                                <template v-else>
                                    <template v-if="details.product">
                                    <span v-if="details.product.product_type_id == type_form">
                                        {{
                                            parseFloat(details.price) + parseFloat(details.other_price_form) - parseFloat(details.discount_special)
                                        }}
                                    </span>
                                        <span v-else>{{ details.price }}</span>
                                    </template>
                                </template>
                            </td>
                            <!--+เบต็ด-->
                            <td>
                                <input class="form-control"
                                       :disabled="details.checkSpecial"
                                       v-on:input="calculatePromotionArray(form.details)"
                                       v-model="details.other_price"/>
                            </td>
                            <!--ส่วนลดพิเศษ--->
                            <td>
                                <!--{{details.discount_price}}-->
                                <template v-if="details.product && details.product.product_type_id == type_form">
                                    <template v-if="product_promotion_other.includes(details.product.id)">
                                        <b-form-select v-model="details.discount_price"
                                                       v-on:input="calculatePromotionArray(form.details)"
                                                       :options="discount_price">
                                        </b-form-select>
                                    </template>
                                </template>
                                <template v-else>
                                    <template
                                        v-if="details.product && product_promotion_other.includes(details.product.id)">
                                        <input class="form-control"
                                               v-on:input="calculatePromotionArray(form.details)"
                                               v-model="details.discount_special"/>
                                    </template>
                                </template>
                            </td>
                            <!--โปรโมชั่น-->
                            <td>
                                <template v-if="form.customer && form.customer.ban_promotion">
                                    <span style="color: red">ลูกค้าคนนี้ถูกแบนโปรโมชั่น</span>
                                </template>
                                <template v-else>
                                    <b-form-select v-model="details.promotion_id"
                                                   v-on:input="calculatePromotionArray(form.details)">
                                        <option v-for="data in details.option_promotion"
                                                :value="data.value">
                                            {{ data.text }}
                                        </option>
                                    </b-form-select>
                                </template>
                            </td>
                            <!--ส่วดลด-->
                            <td align="center">
                                <!--{{details.discount_special}}-->
                                {{ details.discount | currency }}฿
                            </td>
                            <!--ราคา/รวม-->
                            <td>
                                <template>{{ details.total | currency }}</template>
                            </td>
                            <!--เพิ่ม / ลบ-->
                            <td>&nbsp;
                                <a @click="showModalDelete(index)">
                                    <icon name="trash-alt"></icon>
                                </a>
                            </td>
                        </tr>
                        <!--input product-->
                    </template>
                    <!---invoice one--->
                    <tr>
                        <td></td>
                        <td>
                            <multiselect
                                v-model="detail.product"
                                :options="optionProducts"
                                :max-height="200"
                                track-by="sku"
                                :customLabel="LabelSkuWithName"
                                :show-labels="false"
                                @input="setProductName(detail.product)"
                                placeholder="โปรดเลือกรายการสินค้า"
                                style="width: 100%;min-width: 150px;">
                            </multiselect>
                        </td>
                        <td>{{ product_name }}</td>
                        <td align="center">
                            <input :disabled="!detail.product"
                                   v-on:focusout="calculatePromotion(detail)"
                                   class="form-control" style="width: 100px;"
                                   v-model="detail.quantity"/>
                        </td>
                        <!--ราคา/หน่วย--->
                        <td align="center">
                            <template v-if="form.customer && form.customer.special_customer == 1">
                                <input class="form-control" v-model="detail.price"/>
                            </template>
                            <template v-else>
                                <template v-if="detail.product">
                                    <span v-if="detail.product.product_type_id == type_form">
                                        {{
                                            parseFloat(detail.price) + parseFloat(detail.other_price_form) - parseFloat(detail.discount_special)
                                        }}
                                    </span>
                                    <span v-else>{{ detail.price }}</span>
                                </template>
                            </template>
                        </td>
                        <!--+เบ็ดเตล็ด--->
                        <td>
                            <input class="form-control"
                                   :disabled="detail.checkSpecial"
                                   v-on:input="calculatePromotion(detail)"
                                   v-model="detail.other_price"/>
                        </td>
                        <!--ส่วนลดพิเศษ--->
                        <td>
                            <template v-if="detail.product && detail.product.product_type_id == type_form">
                                <template v-if="detail.product && product_promotion_other.includes(detail.product.id)">
                                    <b-form-select v-model="detail.discount_price"
                                                   v-on:input="calculatePromotion(detail)"
                                                   :options="discount_price">
                                    </b-form-select>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="detail.product && product_promotion_other.includes(detail.product.id)">
                                    <input class="form-control"
                                           v-on:input="calculatePromotion(detail)"
                                           v-model="detail.discount_special"/>
                                </template>
                            </template>
                        </td>
                        <td>
                            <template v-if="form.customer && form.customer.ban_promotion">
                                <span style="color: red">ลูกค้าคนนี้ถูกแบนโปรโมชั่น</span>
                            </template>
                            <template v-else>
                                <b-form-select v-model="detail.promotion_id"
                                               v-on:input="calculatePromotion(detail)">
                                    <option v-for="data in detail.option_promotion"
                                            :value="data.value">
                                        {{ data.text }}
                                    </option>
                                </b-form-select>
                            </template>
                        </td>
                        <td>
                            <template v-if="detail.discount_status_id==1">
                                {{ detail.discount }}฿
                            </template>
                            <template v-else-if="detail.discount_status_id==2">
                                {{ detail.discount }}%
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            {{ detail.total | currency }}
                        </td>
                        <td>
                            <button type="button"
                                    :disabled="on_loading"
                                    class="btn btn-primary"
                                    @click="onAddProduct(detail)">+
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <br/>
            <div>
                <span style="color: red;font-size: 15px">สินค้าประเภท 'ชุดรวมสินค้า' จะคิดราคาขนส่งรวมเป็น 2 เท่า เพราะมีสินค้า 2 ชนิดใน 1 SKU</span>
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">ประเภทสินค้า</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">ราคา/หน่วย</th>
                        <th scope="col">ราคาขนส่งรวม</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--transport table-->
                    <template v-for="(transport, index) in transport_price_array">
                        <tr :class="{ 'transport-style': transport.product_type_id == 12 }">
                            <td>
                                {{ ++index }}
                            </td>
                            <td>
                                <template v-if="transport.product_type_id">
                                    {{ transport.product_type_name }}
                                    <span v-if="transport.form_size_id">({{ transport.form_size_name }})</span>
                                    <span v-if="transport.pack_type">({{ transport.pack_type_name }})</span>
                                    <span v-if="transport.product_type_id == 12">(*2)</span>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                {{ transport.quantity | amount }}
                            </td>
                            <td>
                                <template v-if="transport.transport_unit_price">
                                    {{ transport.transport_unit_price }}
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                {{ transport.transport_total | currency }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
                <div>**เงื่อนค่าขนส่ง</div>
                <div>1.แก้วและเบ็ดเตล็ดที่เป็นลัง จะคิดค่าขนส่งเป็น 70% ของราคาขนส่งโฟมเล็ก</div>
                <div>2.กรณีหลอดที่เป็นลูก คิดเรทตามโฟมใหญ่ ถ้าไม่มีโฟมใหญ่ให้คิดคามเรทขนส่งโฟมเล็ก</div>
                <div>3.ฝา หน่วย เป็นลัง คิดเป็น 70% ของโฟมเล็ก</div>
                <div>4.กรณีสินค้าหน่วยเป็นลูกคิดเป็น 70% ของโฟมเล็ก และ เป็นลังคิดเรทขนส่งราคาเดียวกับโฟมเล็ก</div>
                <div>5.ขวดเป็นลูก คิดเรทโฟมใหญ่</div>
            </div>

            <!--ยอดรวม-->
            <div class="total-padding">
                <div class="form-check" v-if="creditNote">
                    <input type="checkbox"
                           class="form-check-input"
                           v-model="check_credit"
                           :disabled="check_credit2"
                           id="credit">
                    <label class="form-check-label" for="credit"
                           v-bind:class="{'danger': check_credit}">
                        จ่ายเงินเกิน : {{ creditNote }} บาท
                    </label>
                </div>
                <div class="form-check" v-if="creditNote">
                    <input type="checkbox"
                           :disabled="check_credit"
                           class="form-check-input"
                           v-model="check_credit2"
                           id="credit_2">
                    <label class="form-check-label" for="credit_2"
                           v-bind:class="{'danger': check_credit2}">
                        จ่ายเงินเกิน :
                    </label>
                    <input class="form-control w-25 float-right"
                           type="number"
                           v-model="creditNote2"
                           :disabled="check_credit || (!check_credit && !check_credit2)"
                           placeholder="จ่ายเงินเกิน(บาท)"/>
                </div>
                <br/>
                <div class="form-group row text-primary text-right"
                     style="padding-top: -10px;font-size: 15px; font-weight: normal"
                     v-if="form.status_receive">
                    <div class="col form-check" :class="{'text-primary' :form.status_foam_discount}">
                        <input type="checkbox"
                               v-model="form.status_foam_discount"
                               :value="1"
                               id="foam_discount"
                               class="form-check-input"/>
                        <label class="form-check-label" for="foam_discount">ส่วนลดโฟมแพ็คละ 10 บาท จำนวน
                            {{ sum_quantity_form }} แพ็ค = {{ sum_price_form | currency }} บาท</label>
                    </div>
                </div>
                <div class="form-group row text-primary text-right"
                     style="margin-top: -10px ;font-size: 15px; font-weight: normal"
                     v-if="form.status_receive">
                    <div class="col form-check" :class="{'text-primary' :form.status_glass_discount}">
                        <input type="checkbox"
                               v-model="form.status_glass_discount"
                               :value="1"
                               id="glass_discount"
                               class="form-check-input"/>
                        <label class="form-check-label" for="glass_discount">ส่วนลดแก้วแพ็คละ 5 บาท จำนวน
                            {{ sum_quantity_glass }} แพ็ค = {{ sum_price_glass | currency }} บาท</label>
                    </div>
                </div>
                <div class="form-group row total-padding text-primary" v-if="form.status_receive">
                    <div class="col font-weight-bold">
                        <span>ส่วนลดพิเศษมารับเอง</span>
                    </div>
                    <div>
                        <input class="form-control" placeholder="ส่วนลด (บาท)"
                               v-model="form.discount_special" disabled/>
                    </div>
                </div>
                <div style="padding-left: 25px">
                    ค่าคอมมิชชั่นเซลล์ : {{ calculateCommissionSale | currency }} บาท
                </div>
                <div class="form-group row total-padding">
                    <div class="col font-weight-bold">
                        <span>ส่วนลดอื่นๆที่ต้องการลดเพิ่มเติม</span>
                    </div>
                    <div>
                        <input class="form-control"
                               :disabled="canViewSuperAdmin || this.user.username == '20533' ? false : true"
                               v-model="form.other_discount"
                               placeholder="ส่วนลดอื่นๆ"/>
                    </div>
                </div>
                <div class="form-group row total-padding" v-if="form.other_discount_user">
                    <div class="col font-weight-bold">
                        <span>ผู้ใส่ส่วนลด : {{ form.other_discount_user_model.name }}</span>
                    </div>
                </div>
                <span style="padding-left: 25px">ยอดรวม : {{ totalPrice | currency }} บาท</span>
                <br/>
                <span style="padding-left: 25px">คืนเงินจาก CN : {{ form.cash_back | currency }} บาท</span>
                <br/>
                <span style="padding-left: 25px">ค่าขนส่ง : {{ total_transport_price | currency }} บาท</span>
                <br/>
                <span
                    style="padding-left: 25px;font-weight: bold">รวมทั้งสิ้น : {{
                        parseFloat(totalPriceCreditOrCashBack) + parseFloat(total_transport_price) | currency
                    }} บาท</span>
            </div>
            <!--บันทึก-->
            <div style="color: red">
                **แก้ไข TN ไม่ได้เนื่องจากมีการสร้าง RV หรือ ใบกำกับภาษีไปแล้ว (ควรลบ RV หรือใบกำกับภาษีก่อน
                จึงจะมาสามารถแก้ไข TN ได้)
            </div>
            <div class="text-right">
                <br/>
                <template v-if="form.id">
                    <button class="btn btn-success mb-2 mx-3"
                            v-if="conditionConfirm"
                            :disabled="on_loading"
                            @click="saveInvoice('save&print')">
                        <icon name="save"></icon>
                        บันทึกบิลขาย & พิมพ์
                    </button>
                </template>
                <template v-else>
                    <button class="btn btn-success mb-2 mx-3"
                            :disabled="disable_save || on_loading"
                            @click="saveInvoice('save&print')">
                        <icon name="save"></icon>
                        บันทึก & พิมพ์บิลขาย
                    </button>
                </template>
                <!--                <button class="btn btn-success mb-2 mx-3"-->
                <!--                        :disabled="!invoice_id"-->
                <!--                        @click="printInvoice">-->
                <!--                    <icon name="file"></icon> พิมพ์บิลขาย </button>-->
            </div>
            <div style="display: none">{{ validateDiscountSpecialDetail }}</div>
            <div style="display: none">{{ validateDiscountSpecialDetails }}</div>
            <pre class="alert-primary" style="display: none">{{ sumQuantityProduct }}</pre>
        </div>
        <!--Modal Delete-->
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <span
                    v-if="delete_index != null && form.details.length > 0">{{
                        form.details[delete_index].product.sku + ' - ' + form.details[delete_index].product.name
                    }}</span>
                <br/>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="removeProduct">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-outline-secondary"
                        @click="hideModalDelete">ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--Modal Confirm-->
        <b-modal
            ref="approve_invoice_edit"
            hide-header
            hide-footer>
            <confirm-modal :msg="msg" @submit="approveInvoiceEdit"></confirm-modal>
        </b-modal>
        <!--Modal Confirm-->
        <b-modal size="lg"
                 ref="alert_invoice_form_modal"
                 hide-header
                 hide-footer>
            <div style="text-align: center;">
                <h4 style="white-space: pre;">{{ alertInvoiceFormModal.msg }}</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="closeAlertInvoiceFormModal">ตกลง
                </button>
            </div>
        </b-modal>
        <!--loading-->
        <b-modal ref="loading" hide-header hide-footer>
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!--        <pre class="alert-success">{{calculateCommissionSale}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import FormCheckbox from "bootstrap-vue/src/components/form-checkbox/form-checkbox";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import MaskedInput from 'vue-masked-input'

import {domain} from "../../../util/Constants";
import {canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";
import ConfirmModal from "../../Utility/ConfirmModal";

export default {
    name: "invoice-show",
    props: {
        id: {default: null},
        createFromOrder: {default: false},
        reopenStatus: {default: false}
    },
    components: {
        ConfirmModal,
        Loading,
        FormCheckbox,
        Multiselect,
        DatePicker,
        MaskedInput
    },
    data() {
        return {
            msg: '',
            status_loading: '',
            credit_confirm_status: false,
            action_invoice: '',
            confirm_status: null,
            invoice_id: null,
            discountReceive: "",
            disable_save: false,
            sum_quantity_glass: 0,
            sum_quantity_form: 0,
            sum_price_form: 0,
            sum_price_glass: 0,
            transport_array_test: [],
            optionTransportation: [],
            optionCustomer: [],
            optionCustomerOther: [],
            optionOrder: [],
            orderSelected: [],
            total: 0,
            date: "",
            currentDate: "",
            delete_index: null,
            items: [
                {
                    text: "รายการใบแจ้งหนี้",
                    to: {name: "invoices"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            optionStatus: [],
            detail: {
                product_id: "",
                quantity: null,
                price: 0,
                promotion: "",
                discount: 0,
                discount_status_id: 1,
                total: 0,
                promotion_id: null,
                other_price: 0,
                other_price_form: 0,
                other_price_total: 0,
                product: "",
                discount_special: 0,
                discount_price: 0,
                checkSpecial: true,
                option_promotion: [
                    {
                        value: null,
                        text: "โปรโมชั่น"
                    },
                ],
            },
            product_name: "",
            promotion: [{text: "promotion", value: ""}],
            discount_type: [
                {value: '1', text: '฿'},
                {value: '2', text: '%'}
            ],
            alertInvoiceFormModal: {
                msg: ""
            },
            check_credit: false,
            check_credit2: false,
            creditNote2: 0,
            priceForm: [
                {value: null, text: "ไม่มีราคา"},
                {value: 1, text: "+1"},
                {value: 2, text: "+2"},
                {value: 3, text: "+3"},
                {value: 4, text: "+4"},
                {value: 5, text: "+5"},
                {value: 6, text: "+6"},
                {value: 7, text: "+7"},
                {value: 8, text: "+8"},
                {value: 9, text: "+9"},
                {value: 10, text: "+10"},
            ],
            transport_price_array: [],
            type_form: 1,
            type_transport: 4,
            disable_select: false,
            test: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            disabledtransport: true,
            product_out_stock: '',
            on_loading: true,
        };
    },
    async created() {
        this.transport_array_test = [];
        this.domain = domain;
        this.invoice_id = this.form.id;
        this.checkInvoiceFormDriver();
        this.disabled_transport();
        if (!this.form.id) {
            this.getCurrentDate();
        }
        if (this.form.customer) {
            this.getPromotionOther();
        }
        // If create invoice.
        if (this.id === null) {
            this.$store.dispatch("Invoice/generateOrder");
        } else {
            if (this.form.credit) {
                this.check_credit = true;
            }
        }
        // if (this.form.order_id) {
        //     this.disable_select = true;
        // } else {
        //     this.$store.dispatch('Driver/getAll');
        // }

        //reopenStatus
        if (this.reopenStatus) {
            // this.addDays();
            this.form.invoice_status_id = 4;
            this.form.reopen_status = 1;
        }
        this.transport_price_array = this.form.invoice_transport_details;
        this.$store.dispatch("TransportType/setTransportTypes");
        this.$store.dispatch("Common/setInvoiceStatus");
        this.$store.dispatch("Products/getProductAll");
        this.$store.dispatch("Transportation/getAll").then(res => {
            this.optionTransportation = res;
        });
        await this.$store.dispatch("Order/allOrderOption").then(res => {
            this.optionOrder = res;
        });
        this.$store.dispatch("Order/setDiscountPrice");
        this.getCustomerAll();
        this.getCustomerOther(this.form.customer,true);
        if (this.form.details.length > 0) {
            this.calculatePromotionArray(this.form.details);
        }
        this.getDriverFormTransportType();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.Invoice.invoiceForm;
            },
            invoiceStatus: state => {
                return [
                    {
                        value: null,
                        text: "สถานะ"
                    },
                    ...state.Common.invoice_status
                        .filter(status => status.id != 1)
                        .map(status => ({
                            value: status.id,
                            text: status.name
                        }))
                ];
            },
            optionProducts: state => {
                return state.Products.product_all;
                // return state.Products.product_all.filter(product => { //true return all
                //     if(product.short_name == null){
                //         product.short_name = "";
                //     }
                //     return !state.Invoice.invoiceForm.details.find(detail => { //true => return details
                //         if(detail.product){
                //             return detail.product.id === product.id
                //         }
                //     })
                // })
            },
            optionDriver: state => {
                return state.Driver.optionDriverInvoice.filter(driver => !driver.cancel_status);
            },
            orderOption: state => {
                return state.Order.orderOption;
            },
            invoice_driver: state => {
                return state.Invoice.invoice_driver.filter(driver => driver.save_exportation.length < 1);
            },
            promotions: state => {
                return [
                    {
                        value: null,
                        text: "โปรโมชั่น"
                    },

                    ...state.Promotion.promotion_all.map(promotion => ({
                        value: promotion.id,
                        text: promotion.name,
                    }))
                ]
            },
            promotion_detail: state => {
                return state.Invoice.promotion_detail;
            },
            user: state => { //superadmin คุณมด permission for approve
                return state.Auth.user;
            },
            product_promotion_other: state => {
                return state.Order.product_promotion_other;
            },
            max_discount: state => {
                return state.Order.max_discount;
            },
            discount_price: state => {
                return state.Order.discount_price;
            },
            optionTransportType: state => {
                return [
                    {
                        value: null,
                        text: "เลือกประเภทรถ"
                    },
                    ...state.TransportType.transportTypeList.map(status => ({
                        value: status.id,
                        text: status.name
                    }))

                ];
            },
        }),
        // disabled_transport (){
        //     if(this.form.status_receive || this.form.status_sale_receive){
        //         return true;
        //     }
        //     return false;
        // },
        totalPrice() {
            let discount_special = 0;
            let other_discount = 0;
            let total = this.form.details.reduce((carry, detail) => {
                return carry + detail.total
            }, 0);
            if (this.form.status_receive) {
                if (this.form.discount_special > 0) {
                    discount_special = this.form.discount_special;
                }
                total = parseFloat(total) - parseFloat(discount_special)
            }
            if (this.form.other_discount > 0) {
                other_discount = this.form.other_discount;
                total = parseFloat(total) - parseFloat(other_discount)
            }
            return parseFloat(total).toFixed(2);

        },
        totalPriceCreditOrCashBack() {
            let total = this.totalPrice;
            if (total > 0) {
                if (this.check_credit) {
                    if (this.form.credit) {
                        total = total - parseFloat(this.form.credit);
                    } else {
                        total = total - parseFloat(this.form.customer.credit_note);
                    }
                }
                if (this.check_credit2) {
                    if (this.form.credit) {
                        total = total - parseFloat(this.form.credit);
                    } else {
                        if (!this.creditNote2) this.creditNote2 = 0;
                        if (this.creditNote2 && this.creditNote2 >= this.form.customer.credit_note) this.creditNote2 = this.form.customer.credit_note;
                        total = total - parseFloat(this.creditNote2);
                    }
                }
                if (this.form.cash_back) {
                    total = total - parseFloat(this.form.cash_back);
                }
                if (total < 0) {
                    total = 0;
                }
            }
            return parseFloat(total).toFixed(2);
        },
        total_transport_price() {
            if (this.transport_price_array && this.transport_price_array.length > 0) {
                let transport_price = this.transport_price_array.reduce((carry, transport) => {
                    if (!transport.transport_total) {
                        transport.transport_total = 0;
                    }
                    return carry + parseFloat(transport.transport_total);
                }, 0);
                return parseFloat(transport_price).toFixed(2);
            }
            return 0;
        },
        totalDiscount() {
            const total_discount = parseFloat(this.detail.quantity) *
                (parseFloat(this.detail.price) + parseFloat(this.detail.other_price) - parseFloat(this.detail.discount_special));
            return parseFloat(total_discount).toFixed(2);
        },
        creditNote() {
            if (this.form.credit) {
                return this.form.credit
            } else {
                if (this.form.customer && this.form.customer.credit_note) {
                    return this.form.customer.credit_note;
                } else {
                    return null;
                }
            }
        },
        conditionSubmit() {
            // return this.form.reopen_status == 1;
        },
        conditionConfirm() {
            return this.canViewSuperAdmin
                && !this.form.status_product_return && !this.form.payoff_status_id && !this.form.status_tax
                && this.form.invoice_status_id !== 5 && this.form.invoice_status_id !== 6
        },
        validateQuantity() {
            let flag = 1;
            this.form.details.forEach(detail => {
                if (detail.product) {
                    if (detail.quantity > detail.product.quantity) {
                        flag = 0;
                        this.product_out_stock += detail.product.name + "\n"
                    }
                }
            });
            return flag;
        },
        validateQuantity_edit() {
            let flag = 1;
            this.form.details.forEach(detail => {
                if (detail.product) {
                    if (detail.quantity > detail.real_stock) {
                        flag = 0;
                        this.product_out_stock += detail.product.name + "\n"
                    }
                }
            });
            return flag;
        },
        validateDiscountSpecialDetail() {
            if (!this.detail.discount_price) {
                if (this.detail.discount_special) {
                    if (this.detail.discount_special > this.max_discount) {
                        this.detail.discount_special = this.max_discount
                    }
                }
            }
            return true;
        },
        validateDiscountSpecialDetails() {
            this.form.details.forEach(detail => {
                if (!detail.discount_price) {
                    if (detail.discount_special) {
                        if (detail.discount_special > this.max_discount) {
                            detail.discount_special = this.max_discount
                        }
                    }
                }
            });
            return true;
        },
        sumQuantityProduct() {
            //หากเลือกมารับเอง
            this.sum_quantity_glass = 0;
            this.sum_quantity_form = 0;
            this.sum_price_form = 0;
            this.sum_price_glass = 0;
            this.form.discount_special = 0;
            let form_type = 1;
            let glass_type = 2;
            this.form.details.forEach(detail => {
                if (detail.product && detail.product.product_type_id == form_type && this.form.status_foam_discount) {
                    this.sum_quantity_form += parseFloat(detail.quantity);
                }
                if (detail.product && detail.product.product_type_id == glass_type && this.form.status_glass_discount) {
                    this.sum_quantity_glass += parseFloat(detail.quantity);
                }
            });
            this.sum_price_form = parseFloat(this.sum_quantity_form) * 10;
            this.sum_price_glass = parseFloat(this.sum_quantity_glass) * 5;
            if (this.form.status_receive) {
                this.form.discount_special = parseFloat(this.sum_price_form) + parseFloat(this.sum_price_glass);
            }
            return this.form.discount_special;
        },
        invoiceStatusName() {
            let invoice_status = this.invoiceStatus.find(status => status.value == this.form.invoice_status_id);
            return invoice_status.text;
        },
        calculateCommissionSale() {
            /*คิดค่าคอมมิชชั่นเซลล์ total * commission_product %*/
            let commission_sale = 0;
            this.form.details.forEach(detail => {
                let commission = detail['product'] && parseFloat(detail['product']['commission']) ? parseFloat(detail['product']['commission']) : 0;
                let details_total = parseFloat(detail['total']) ? parseFloat(detail['total']) : 0;
                commission_sale += parseFloat((parseFloat(details_total) * (parseFloat(commission) / 100)));
            })
            this.form.commission_sale = commission_sale.toFixed(2);
            return this.form.commission_sale;
        }
    },
    methods: {
        disabled_transport() {
            if (this.form.status_receive || this.form.status_sale_receive) {
                this.disabledtransport = true;
            } else {
                this.disabledtransport = false;
            }
        },
        searchOrder_id(searchQuery) {
            if (searchQuery != '') {
                this.$store.dispatch("Order/allOrderOption", searchQuery).then(res => {
                    this.optionOrder = res;
                });
            }
        },
        setForm(id) {
            this.msg = 'กำลังเรียกข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch('Invoice/clearFormDataReOpen',this.reopenStatus?this.form.invoice_id:'');
            this.$store.dispatch("Order/showOrder", id.id).then(() => {
                this.$store.dispatch("Order/createInvoiceFromOrder", id.id).then(() => {
                    this.getInvoiceTransportPrice();
                    this.hideLoadingModal();
                    this.optionOrder = [];
                })
                // .then(()=>{
                // if(this.status_create_invoice){
                //     this.$store.dispatch("Invoice/generateOrder");
                //     this.hideLoadingModal();
                // }else{
                //     this.msg = 'ใบจองนี้มีการเปิก TN ไปแล้ว / มีการปิดใบจองไปแล้ว';
                //     this.status_loading = 3;
                // }
                // }).catch(err=>{
                //     this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                //     this.status_loading = 3;
                // });
            }).catch(() => {
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                this.status_loading = 3;
            });
        },
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.short_name}`
            }
        },
        customWithName(option) {
            return `${option.store_name} - ${option.customer_id}`
        },
        nameWithType(option) {
            if (this.optionDriver.length > 0) {
                return `${option.name} - ${option.transport_type ? option.transport_type.name : '-'}`
            }
        },
        orderDO(option) {
            if (this.optionOrder.length > 0) {
                return `${option.order_id}`
            }
        },
        getCustomerOther(customer,onLoad = false) {
            if (customer) {
                this.$store.dispatch("Customer/getCustomerOtherById", customer.id).then(res => {
                    this.optionCustomerOther = res;
                    if (!onLoad || res.length === 0) {
                        this.form.customer_other_id = null;
                        this.form.customer_other = null;
                    }
                }).then(() => {
                    this.invoiceTransportPrice();
                }).then(() => {
                    this.getPromotionOther();
                    this.getPromotionByProductId(this.detail.product);
                })
            }
        },
        showModalDelete(index) {
            this.delete_index = index;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showModalApproveEdit() {
            this.$refs.approve_invoice_edit.show();
        },
        hideModalApproveEdit() {
            this.$refs.approve_invoice_edit.hide();
        },
        closeAlertInvoiceFormModal() {
            this.$refs['alert_invoice_form_modal'].hide()
        },
        onAddProduct(submitData) {
            this.on_loading = true;
            submitData.quantity = parseFloat(submitData.quantity);
            submitData.price = parseFloat(submitData.price);
            submitData.discount_status_id = parseInt(submitData.discount_status_id);
            submitData.discount = parseFloat(submitData.discount);
            submitData.total = this.totalDiscount - parseFloat(submitData.discount);
            this.alertInvoiceFormModal.msg = "";
            if (submitData.product === "" || submitData.product === null) {
                // alert('กรุณาเลือกรายการสินค้า');
                this.alertInvoiceFormModal.msg = "กรุณาเลือกรายการสินค้า";
                this.$refs['alert_invoice_form_modal'].show()
                this.on_loading = false;
                return false;
            } else if (submitData.quantity < 1) {
                // alert('กรุณาใส่จำนวน');
                this.alertInvoiceFormModal.msg = "กรุณาใส่จำนวน";
                this.$refs['alert_invoice_form_modal'].show()
                this.on_loading = false;
                return false;
            } else if (submitData.product.quantity < submitData.quantity) {
                // alert("ไม่สามารถสั่งซื้อได้ เนื่องจากจำนวนในคลังไม่เพียงพอ")
                this.alertInvoiceFormModal.msg = "ยอดคงเหลือไม่เพียงพอต่อการจำหน่าย\n" + submitData.product.name;
                this.$refs['alert_invoice_form_modal'].show();
                this.on_loading = false;
                return false;
            } else {
                this.$store.dispatch("Invoice/addProduct", submitData).then(() => {
                    this.product_name = "";
                    this.detail = {
                        product_id: "",
                        quantity: null,
                        price: 0,
                        promotion: "",
                        discount: 0,
                        discount_status_id: 1,
                        total: 0,
                        promotion_id: null,
                        other_price: 0,
                        other_price_form: 0,
                        other_price_total: 0,
                        product: "",
                        discount_special: 0,
                        discount_price: 0,
                        checkSpecial: true,
                        option_promotion: [
                            {
                                value: null,
                                text: "โปรโมชั่น"
                            },
                        ],
                    };
                    this.invoiceTransportPrice();
                });
            }
        },
        removeProduct() {
            this.on_loading = true;
            this.$store.dispatch("Invoice/removeProduct", this.delete_index).then(() => {
                this.delete_index = null;
                this.getInvoiceTransportPrice();
            });
            this.hideModalDelete();
        },
        setProductName(product) {
            if (product) {
                this.product_name = product.name;
                this.detail.price = product.price;
                this.getPromotionByProductId(product);
            }
            if (this.form.customer && this.form.customer.id == 24 && (product.id == 14 || product.id == 72) && product.product_type_id == 1) {
                this.detail.checkSpecial = false;
            } else if (product.product_type_id == 1) {
                this.detail.checkSpecial = true;
            } else {
                this.detail.checkSpecial = false;
            }
        },
        saveInvoice(action) {
            this.action_invoice = action;
            this.alertInvoiceFormModal.msg = "";
            if (this.form.details.length < 1) {
                this.alertInvoiceFormModal.msg = "กรุณาเพิ่มรายการสินค้า";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (!this.form.status_receive && !this.form.status_sale_receive && !this.form.transport_type_id) {
                this.alertInvoiceFormModal.msg = "ไม่มีประเภทรถ";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (this.form.customer === null) {
                this.alertInvoiceFormModal.msg = "กรุณาเลือกลูกค้า";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if ((!this.form.status_receive && !this.form.status_sale_receive) && !this.form.transport_type_id) {
                this.alertInvoiceFormModal.msg = "โปรดเลือกประเภทรถ";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (!this.form.status_receive && !this.form.status_sale_receive && !this.form.driver) {
                this.alertInvoiceFormModal.msg = "โปรดเลือกคนขับรถ";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (!this.form.status_receive && !this.form.status_sale_receive && this.form.transport_type_id == this.type_transport && !this.form.transportation) {
                this.alertInvoiceFormModal.msg = "กรุณาเลือกรายชื่อขนส่ง";
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (!this.id && this.validateQuantity != 1) {
                this.alertInvoiceFormModal.msg = "ยอดคงเหลือไม่เพียงพอต่อการจำหน่าย\n" + this.product_out_stock;
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (this.id && this.validateQuantity_edit != 1) {
                this.alertInvoiceFormModal.msg = "ยอดคงเหลือไม่เพียงพอต่อการจำหน่าย\n" + this.product_out_stock;
                this.$refs['alert_invoice_form_modal'].show();
                return false;
            } else if (this.reopenStatus && !this.confirm_status) {
                this.msg = "ยืนยันสถานะ " + this.invoiceStatusName + " ในการแก้ไข TN เดิม ?"
                this.showModalApproveEdit();
                return false;
            } else if (this.form.customer.credit_note && !this.credit_confirm_status) {
                this.msg = 'ลูกค้าคนนี้มีเครดิตเงินเกิน คุณเลือกเครดิตเงินเกินแล้วใช่หรือไม่ '
                this.showModalApproveEdit();
                return false;
            } else {
                let promotion = this.calculateOnlyPromotion(this.form.details)
                this.$store.dispatch("Invoice/promotionInvoiceMultiple", promotion).then(() => {
                    if (this.form.transport_type_id == 4) {
                        this.form.status_transport_other = false;
                    }
                    if (this.form.status_receive) {
                        this.form.transport_type_id = "";
                        this.form.driver = "";
                    }
                    if (!this.form.status_receive && !this.form.status_sale_receive && !this.form.transport_type_id) {
                        this.form.transport_type_id = this.form.driver.transport_type_id;
                    }
                    this.form.transport_fee = this.total_transport_price;
                    this.form.invoice_transport_details = this.transport_price_array;
                    if (!this.form.invoice_transport_details) {
                        this.form.invoice_transport_details = [];
                    }
                    if (this.form.transportation) {
                        this.form.transportation_id = this.form.transportation.id;
                    }
                    //set check credit
                    if (this.check_credit || this.check_credit2) {
                        if (this.check_credit) this.form.credit = this.creditNote;
                        if (this.check_credit2) this.form.credit = this.creditNote2;
                        this.form.check_if_credit = true
                    } else {
                        this.form.check_if_credit = false
                    }
                    if (this.form.customer_other) {
                        this.form.customer_other_id = this.form.customer_other.id;
                    } else {
                        this.form.customer_other_id = "";
                    }
                    if (this.reopenStatus) {
                        this.form.reopen_status = 1;
                    }
                    let saveData = {
                        id: this.id,
                        action: action
                    };
                    let customer = "";
                    //add action for check state in backend
                    if (this.form.customer) {
                        const customer = {
                            store_name: this.form.customer.store_name,
                            first_name: this.form.customer.first_name,
                            customer_id: this.form.customer.customer_id,
                            phone: this.form.customer.phone,
                            address: this.form.customer.address,
                            province: "",
                            district: "",
                            sub_district: "",
                        };
                        if (this.form.customer.province) {
                            customer.province = this.form.customer.province.name
                        }
                        if (this.form.customer.district) {
                            customer.district = this.form.customer.district.name
                        }
                        if (this.form.customer.sub_district) {
                            customer.sub_district = this.form.customer.sub_district.name
                        }
                    }
                    let transportation = "";
                    if (this.form.transportation) {
                        transportation = this.form.transportation.name;
                    }
                    let driver = "";
                    if (this.form.driver) {
                        driver = {
                            transportation: transportation,
                            transport_type: this.form.driver.transport_type ? this.form.driver.transport_type.name : '',
                            name: this.form.driver.name,
                            phone: this.form.driver.phone.toString(),
                        };
                    }
                    let sale = "";
                    if (this.form.customer.sale) {
                        sale = {
                            sale_id: this.form.customer.sale.sale_id,
                            name: this.form.customer.sale.name
                        };
                    }
                    if (this.form.date) {
                        this.form.date = moment(this.form.date).format("YYYY-MM-DD")
                    }
                    let data = {
                        action: action,
                        order_id: this.form.order_id,
                        date: this.form.date,
                        invoice_id: this.form.invoice_id,
                        customer: customer,
                        sale: sale,
                        driver: driver,
                        details: this.form.details,
                    };
                    if (action === "print") {
                        let printData = $.param(data);
                        window.open(
                            `${domain}/invoice-cover-a5?print=${printData}`,
                            '_blank'
                        );
                    } else if (action === "save") {
                        this.msg = 'กำลังบันทึกบิลขาย กรุณารอสักครู่';
                        this.status_loading = 1;
                        this.showLoadingModal();
                        this.disable_save = true;
                        this.$store.dispatch("Invoice/saveInvoice", saveData)
                            .then(res => {
                                if (res[0] != false) { //save success
                                    this.invoice_id = res.id;
                                    if (this.invoice_id) {
                                        if (this.form.driver && this.transport_price_array.length > 0) {
                                            this.goToDriverShipping(this.form.driver.id);
                                        } else {
                                            // this.goToInvoiceList();
                                            this.hideLoadingModal();
                                        }
                                    }
                                } else if (res[0] == false && res[1] == 'validate') {
                                    this.showLoadingModal();
                                    this.disable_save = false;
                                    this.msg = 'กรุณากรอกข้อมูลให้ครบ';
                                    this.status_loading = 3;
                                } else if (res[0] == false && res[1] == 'limit') {
                                    this.showLoadingModal();
                                    this.disable_save = false;
                                    this.msg = 'ใบจองนี้เปิดครบกำหนดแล้ว';
                                    this.status_loading = 3;
                                } else if (res[0] == false && res[1] == 'max quota') {
                                    this.alertInvoiceFormModal.msg = "ไม่สามารถเปิดบิลได้ \n เนื่องจากสินค้าเปิดครบ/เกิน จำนวนโควต้าแล้ว";
                                    this.$refs['alert_invoice_form_modal'].show()
                                } else if (res[0] == false && res[1] == 'out of date') {
                                    this.alertInvoiceFormModal.msg = "ไม่สามารถเปิดบิลได้ \n เนื่องจากสินค้าเกินช่วงเวลาโควต้าที่กำหนดแล้ว";
                                    this.$refs['alert_invoice_form_modal'].show()
                                } else if (res[0] == false) {
                                    this.alertInvoiceFormModal.msg = res[1] ? res[1] : '';
                                    this.$refs['alert_invoice_form_modal'].show()
                                }
                            })
                    } else {
                        this.disable_save = true;
                        this.msg = 'กำลังบันทึกบิลขาย กรุณารอสักครู่';
                        this.status_loading = 1;
                        this.showLoadingModal();
                        this.$store.dispatch("Invoice/saveInvoice", saveData).then(res => {
                            if (res[0] != false) {
                                this.invoice_id = res.id;
                                this.$store.dispatch('Invoice/clearFormDataNew');
                                this.disable_save = false;
                                this.transport_price_array = [];

                                // let check_can_create_tax = this.checkCanCreateTax(res);
                                // if (check_can_create_tax)
                                //     this.createTaxInvoice(res.id);
                                // else{
                                window.open(domain + "/invoice-pdf/" + res.id);
                                this.hideLoadingModal();
                                this.$router.push({
                                    name: "invoice-form",
                                    params: {id: null}
                                });
                                // }
                            } else if (res[0] == false && res[1] == 'validate') {
                                this.showLoadingModal();
                                this.msg = 'กรุณากรอกข้อมูลให้ครบ';
                                this.status_loading = 3;
                            } else if (res[0] == false && res[1] == 'limit') {
                                this.showLoadingModal();
                                this.msg = 'ใบจองนี้เปิดครบกำหนดแล้ว';
                                this.status_loading = 3;
                            } else if (res[0] == false && (res[1] == 'max quota' || res[1] == 'out of quota')) {
                                this.alertInvoiceFormModal.msg = "ไม่สามารถเปิดบิลได้ \n เนื่องจากสินค้าเปิดครบ/เกิน จำนวนโควต้าแล้ว";
                                this.$refs['alert_invoice_form_modal'].show()
                            }
                            this.disable_save = false;
                        }).catch(err => {
                            this.msg = 'ไม่สามารถบันทึกบิลขายได้';
                            this.status_loading = 3;
                            this.disable_save = false;
                        })
                    }
                });
            }
        },
        checkCanCreateTax(param) {
            // 1
            if (param.customer_id == 1236)
                return false;
            // 2
            if (param.details.filter(x => (x.product_id == 257)).length > 0)
                return false;
            // 3
            if (param.status_not_pay == 1)
                return false;
            // 4
            if (param.customer_other_id)
                return false;
            // 5
            if (param.details.filter(x => [14, 17].includes(x.product.product_type_id)).length > 0)
                return false;
            // 6
            if (param.customer.tax_number == 'NULL' || !param.customer.tax_number)
                return false
            return true;
        },
        createTaxInvoice(invoice_id) {
            this.msg = 'กำลังสร้างใบกำกับภาษี กรุณารอสักครู่';
            this.showLoadingModal();
            let invoices = [];
            if (invoice_id) {
                let data = {
                    invoice_id: invoice_id,
                    date: moment().format("YYYY-MM-DD")
                };
                invoices.push(data);
                this.$store.dispatch("TaxInvoice/saveTaxInvoice", {
                    id: "",
                    data: invoices
                }).then(() => {
                    this.hideLoadingModal();
                    window.open(domain + "/invoice-pdf/" + invoice_id);
                    this.$router.push({
                        name: "invoice-form",
                        params: {id: null}
                    });
                }).catch(() => {
                    this.msg = 'สร้างใบกำกับภาษีไม่สำเร็จ';
                    this.status_report = 3;
                });
            }
        },
        printInvoice() {
            if (this.invoice_id) {
                window.open(domain + "/invoice-pdf/" + this.invoice_id);
                this.goToInvoiceList();
            }
        },
        goToInvoiceList() {
            this.$router.push("/invoices");
        },
        checkInvoiceFormDriver(driver) {
            if (driver && driver.transport_type_id) {
                if (!this.form.transport_type_id) {
                    this.form.transport_type_id = driver.transport_type_id;
                }
                this.$store.dispatch("Invoice/checkInvoiceFromDriver", driver.id);
                this.invoiceTransportPrice();
            }
        },
        addDays() {
            let next_date = moment().add(1, 'days');
            this.form.date = moment(next_date).format("YYYY-MM-DD")
        },
        approveInvoiceEdit(value) {
            if (value) {
                this.confirm_status = 1;
                this.credit_confirm_status = true;
                this.saveInvoice(this.action_invoice);
            }
            this.hideModalApproveEdit();
        },
        calculatePromotion(detail) {
            this.on_loading = true;
            if (this.validateDiscountSpecialDetail) {
                if (detail) {
                    detail.product_id = detail.product.id;
                    let data = {
                        other_price_form: this.form.other_price_form,
                        details: detail,
                    };
                    this.$store.dispatch("Invoice/promotionInvoice", data).then(() => {
                        this.detail = this.promotion_detail;
                        this.on_loading = false;
                    });
                }
            } else {
                this.on_loading = false;
            }
        },
        calculatePromotionArray(details) {
            this.on_loading = true;
            let details_array = [];
            if (details) {
                details.forEach(detail => {
                    if (detail.product) {
                        //set other_price_total variable
                        if (detail.product.product_type_id == this.type_form) {
                            detail.other_price_total = detail.other_price_form
                        } else {
                            detail.other_price_total = detail.other_price
                        }
                    }
                    details_array.push(detail);
                });
            }
            let data = {
                other_price_form: this.form.other_price_form,
                details: details_array
            };
            this.test = data;
            this.$store.dispatch("Invoice/promotionInvoiceMultiple", data).then(() => {
                this.invoiceTransportPrice()
            });
        },
        calculateOnlyPromotion(details) {
            this.on_loading = true;
            let details_array = [];
            if (details) {
                details.forEach(detail => {
                    if (detail.product) {
                        //set other_price_total variable
                        if (detail.product.product_type_id == this.type_form) {
                            detail.other_price_total = detail.other_price_form
                        } else {
                            detail.other_price_total = detail.other_price
                        }
                    }
                    details_array.push(detail);
                });
            }
            let data = {
                other_price_form: this.form.other_price_form,
                details: details_array
            };
            return data
        },
        selectOtherPrice() {
            if (this.detail.product) {
                this.calculatePromotion(this.detail);
            }
            if (this.form.details.length > 0) {
                this.calculatePromotionArray(this.form.details);
            }
        },
        invoiceTransportPrice() {
            if (this.form.customer && (this.form.transport_type_id && this.form.details.length > 0) || this.form.status_sale_receive) {
                this.getInvoiceTransportPrice();
            } else {
                this.on_loading = false;
            }
        },
        getInvoiceTransportPrice() {
            if (this.form.customer) {
                let customer_other = "";
                let fixed_rate_status = this.form.customer.fixed_rate_status;
                if (this.form.customer_other) {
                    customer_other = this.form.customer_other.id;
                    fixed_rate_status = this.form.customer_other.status_transport_form;
                }
                let data = {
                    customer_id: this.form.customer.id,
                    customer_other_id: customer_other,
                    fixed_rate_status: fixed_rate_status,
                    transport_type_id: this.form.transport_type_id,
                    status_transport_other: this.form.status_transport_other,
                    status_sale_receive: this.form.status_sale_receive,
                    details: this.form.details,
                    flag: 1 //มาจาก invoice เพื่อคำนวนค่าขนส่ง
                };
                this.transport_array_test = data;
                if (!this.form.status_receive) {
                    this.$store.dispatch("Invoice/getInvoiceTransportPrice", data).then(res => {
                        if (res) {
                            this.transport_price_array = res;
                        } else {
                            this.transport_price_array = [];
                        }
                    });
                    this.on_loading = false;
                } else {
                    this.on_loading = false;
                }
            } else {
                this.on_loading = false;
            }
        },
        getPromotionOther() {
            if (this.form.customer && this.form.customer.sale) {
                let sale_id = this.form.customer.sale_id;
                this.$store.dispatch("Order/getProductByPromotionOther", sale_id)
            }
        },
        goToDriverShipping(id) {
            this.$store.dispatch('Driver/show', id)
                .then(() => {
                    this.$store.dispatch('DriverDetails/setFilterInvoice', {
                        id,
                        date: this.form.date
                    }).then(() => {
                        this.$store.dispatch('DriverDetails/driverShippingMonth', {
                            driver_id: id,
                            date: this.form.date,
                            transportation_id: this.form.transport_type_id == 4 ? this.form.transportation_id : '',
                        }).then(() => {
                            let routeData = this.$router.resolve({
                                name: 'driver-shipping',
                                params: {id}
                            });
                            window.open(routeData.href, '_blank');
                            this.disable_save = true;
                            this.hideLoadingModal();
                        }).catch(err => {
                            this.msg = 'ไปยังหน้าบันทึกค่าเที่ยวไม่สำเร็จ';
                            this.status_loading = 3;
                        });
                    });
                })
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
            this.form.date = this.currentDate;
        },
        getDriverFormTransportType() {
            if (this.form.transport_type_id) {
                this.$store.dispatch('Driver/getDriverFromInvoice', this.form.transport_type_id);
            }
        },
        getPromotionByProductId(product) {
            if (product) {
                let data = {
                    product_id: product.id,
                    sale_id: this.form.customer ? this.form.customer.sale_id : null,
                };
                this.detail.promotion_id = null;
                this.$store.dispatch("Promotion/setPromotionAll", data).then(() => {
                    this.detail.option_promotion = this.promotions;
                });
            }
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                this.optionCustomer = customers.filter(data => !data.cancel_status);
            });
        },
        setIDTransportation(type) {
            if (type !== null) {
                this.form.driver = null;
                this.getInvoiceTransportPrice();
            }
        },
    }
};
</script>

<style lang="scss" scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}

.danger {
    color: red;
    font-weight: bold;
}

.text-primary {
    font-weight: bold;
}

.text-danger {
    font-weight: bold;
}

.total-padding {
    padding-right: 20px;
    text-align: right;
}

.transport-style {
    color: red;
}
</style>
